import { Typography, FormControl, FormHelperText, InputLabel, Box, Stack } from '@mui/material'
import { CardElement } from '@stripe/react-stripe-js'
import type { StripeCardElementChangeEvent } from '@stripe/stripe-js'

interface AddCreditCardProps {
    handleCreditCardChange: (event: StripeCardElementChangeEvent) => void
    cardError: string | null
}

export default function AddCreditCard({ handleCreditCardChange, cardError }: AddCreditCardProps) {
    return (
        <>
            <Typography variant="h6" sx={{ mt: 3 }}>
                Add a new card
            </Typography>
            <FormControl fullWidth sx={{ mt: '16px' }}>
                <InputLabel shrink sx={{ backgroundColor: 'white' }}>
                    Card Details
                </InputLabel>
                <Box
                    sx={{
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: '4px',
                        p: '12px',
                    }}
                >
                    <CardElement
                        options={{
                            style: {
                                base: {
                                    fontSize: '16px',
                                    color: '#424770',
                                    '::placeholder': { color: '#aab7c4' },
                                },
                                invalid: {
                                    color: '#9e2146',
                                },
                            },
                        }}
                        onChange={handleCreditCardChange}
                    />
                </Box>
                {cardError && (
                    <Stack>
                        <FormHelperText>
                            Sorry, but we had an issue adding your payment method.
                        </FormHelperText>
                        <FormHelperText>For reference: {cardError}</FormHelperText>
                        <FormHelperText>
                            Please try again or contact support if this issue persists.
                        </FormHelperText>
                    </Stack>
                )}
            </FormControl>
        </>
    )
}